// ============================== Online ===========================
export const BaseIP = 'https://dairy.leseschool.in/';   // online


// export const BaseIP="http://192.168.29.113:9082/"  // offline


export const ForgotApi=BaseIP+'api/userlogin/logii'// Forgot API new added
export const EmployeeForgotApi=BaseIP+'api/employee/forgotPassword'// Forgot API Employee

export const DeliveryLoginAPI=BaseIP+'api/userlogin/login'// Delivery login api
export const AdminLoginAPI=BaseIP+'api/admin/login'// admin login api
export const AdminDashboardAPI=BaseIP+'api/dashboard/product-list'// Dashboard table api
export const AdminDashboardCountAPI=BaseIP+'api/dashboard/count-list'// Dashboard count api
export const DeliverPendingDailyListApi=BaseIP+'api/dashboard/list'//PendingCountList api
export const PieChartTotal=BaseIP+'api/dashboard/pendingbill'//PieChartTotal 
export const PieChartDetails=BaseIP+'api/dashboard/customerlist'//PieChartDetails


export const CustomerUpdate=BaseIP+'api/customer/update/'//customer update
export const CustomerAdd=BaseIP+'api/customer/add'//customer Add
export const CustomerDelete=BaseIP+'api/customer/delete/'//customer Add
export const CustomerFindAll=BaseIP+'api/customer/findall'//customer FindAll

export const BranchUpdate=BaseIP+'api/branch/update/'//Branch update
export const BranchAdd=BaseIP+'api/branch/save'//Branch Add
// export const BranchAdd=BaseIP+'api/Branch/add'//Branch Add
export const BranchDelete=BaseIP+'api/branch/delete/'//Branch Add
export const BranchFindAll=BaseIP+'api/branch/findall'//Branch FindAll

export const EmployeeUpdate=BaseIP+'api/employee/update/'//Employee update
export const EmployeeAdd=BaseIP+'api/employee/add'//Employee Add
export const EmployeeDelete=BaseIP+'api/employee/delete/'//Employee Add
export const EmployeeFindAll=BaseIP+'api/employee/findall'//Employee FindAll

export const ProductUpdate=BaseIP+'api/product/update/'//Product update
export const ProductAdd=BaseIP+'api/product/add'//Product Add
export const ProductDelete=BaseIP+'api/product/delete/'//Product Add
export const ProductFindAll=BaseIP+'api/product/findall'//Product FindAll   

export const OrderAllotmentUpdate=BaseIP+'api/orderdetail/update/'//OrderAllotment update
export const OrderAllotmentAdd=BaseIP+'api/orderdetail/add'//OrderAllotment Add
export const OrderAllotmentDelete=BaseIP+'api/orderdetail/delete/'//OrderAllotment Add
export const OrderAllotmentFindAll=BaseIP+'api/orderdetail/findall'//OrderAllotment FindAll   
export const OrderAllotmentOuterFindAll=BaseIP+'api/order/findall'//OrderAllotment FindAll   
export const ProductFindAllOrderAllotment=BaseIP+'api/product/getproduct'//OrderAllotment FindAll   


export const EmployeeToCustomerUpdate=BaseIP+'api/emptocustomer/update/'//EmployeeToCustomer update
export const EmployeeToCustomerAdd=BaseIP+'api/emptocustomer/add'//EmployeeToCustomer Add
export const EmployeeToCustomerDelete=BaseIP+'api/emptocustomer/delete/'//EmployeeToCustomer Add
export const EmployeeToCustomerFindAll=BaseIP+'api/emptocustomer/findall'//EmployeeToCustomer FindAll   

export const DailyStockUpdate=BaseIP+'api/stockdeatil/update/'//DailyStock update 
export const DailyStockAdd=BaseIP+'api/stockdeatil/add'//DailyStock Add
export const DailyStockDelete=BaseIP+'api/stockdeatil/delete/'//DailyStock Add
export const DailyStockFindAll=BaseIP+'api/stockdeatil/findall'//DailyStock FindAll   

export const BillingAdd=BaseIP+'api/productdelivery/add'//Billing Add
export const BillingFindAll=BaseIP+'api/productdelivery/getbilldata'//Billing FindAll   
export const Employeeviewbilldata=BaseIP+'api/bill/employeeviewbilldata'//employeeviewbilldata  
export const Customerviewbilldata=BaseIP+'api/bill/getbillData'//Customerviewbilldata  
export const InnerTableDataCustomer=BaseIP+'api/bill/customerdetail'// inner table data Customer
export const InnerTableDataEmployee=BaseIP+'api/bill/customerdetail'// inner table data Employee
export const SelectAllData=BaseIP+'api/bill/getallbilldata'// all data select


export const StockReturnAdd=BaseIP+'api/stockreturn/add'// save
export const StockReturnUpdate=BaseIP+'api/stockreturn/update/'//  update
export const StockReturnFindall=BaseIP+'api/stockreturn/findAll'//  findall 
export const StockReturnDelete=BaseIP+'api/stockreturn/delete/'//  Delete
export const StockReturnQuantity=BaseIP+'api/stockreturn/stock-pending'//  StockReturnQuantity


export const ExpenseAdd=BaseIP+'api/expense/add'// expense save
export const ExpenseUpdate=BaseIP+'api/expense/update/'// expense update
export const ExpenseFindall=BaseIP+'api/expense/findAll'//expense  findall 
export const ExpenseDelete=BaseIP+'api/expense/delete/'// expense Delete




export const ChangePasswordApi=BaseIP+'api/admin/change-password'// change pass
export const ChangePasswordUserApi=BaseIP+'api/userlogin/change-password'// change pass user

  // ========== delivery api ========================

export const DeliveryDashboardAddOuter=BaseIP+'api/productdelivery/add'//DeliveryDashboard  outer Add
export const DeliveryDashboarConfirm=BaseIP+'api/userlogin/confirm'//DeliveryDashboard  confirm save
export const DeliveryDashboardUpdate=BaseIP+'api/productdelivery/update/'//DeliveryDashboard update
export const DeliveryDashboardAdd=BaseIP+'api/productdelivery/save/'//DeliveryDashboard inner add
export const DeliveryDashboardDelete=BaseIP+'api/productdelivery/delete/'//DeliveryDashboard Add
export const DeliveryDashboardFindAll=BaseIP+'api/productdelivery/findall'//DeliveryDashboard inner FindAll   
export const DeliveryDashboardOuterFindAll=BaseIP+'api/userlogin/findAll'//DeliveryDashboard outer FindAll

export const DeliveryProductUpdate=BaseIP+'api/productdelivery/update/'//DeliveryProduct update
export const DeliveryProductAdd=BaseIP+'api/productdelivery/add'//DeliveryProduct Add
export const DeliveryProductDelete=BaseIP+'api/productdelivery/delete/'//DeliveryProduct Add
export const DeliveryProductFindAll=BaseIP+'api/productdelivery/findall'//DeliveryProduct FindAll 
export const DeliveryProductFindAll1=BaseIP+'api/product/getproduct'//DeliveryProduct FindAll 
export const DeliveryAllInnerData=BaseIP+'api/bill/alldetail'//Delivery all inner Data



export const PaymentFirstApi=BaseIP+'api/bill/paymentdata'//Payment
export const PaymentInnerTableSave=BaseIP+'api/bill/paymentadd'//Payment


export const GeneratebillApi=BaseIP+'api/billdata/generatebill'// generate bill api  
// export const GeneratebillApi2=BaseIP+'api/bill/paymentdata'// generate bill api  


// Report API ===========================================================

export const DeliveryStockADD=BaseIP+'api/report/delivery-report'//DeliveryStockADD
export const ReturnStockAdd=BaseIP+'api/report/stock-report'//ReturnStockAdd
export const GenerateBillAdd=BaseIP+'api/report/billing-report'//GenerateBillAdd
export const PendingBillAdd=BaseIP+'api/report/billing-date-report'//PendingBillAdd
export const PaymentRecAdd=BaseIP+'api/report/payment-receive'//PaymentRecAdd
export const PaymentPendingcAdd=BaseIP+'api/report/payment-pending'//PaymentPendingcAdd
export const ExpenseReport=BaseIP+'api/report/expense-report'//ExpenseReport